<template>
  <span class="account-score">
    <span
      v-if="loading"
      class="loading"
    >
      <i class="el-icon-loading"></i>
    </span>
    <span
      v-else-if="score !== null"
      class="score-value"
    >
      机会分数:{{ score }}
    </span>
    <span
      v-else
      class="score-placeholder"
      >--</span
    >
  </span>
</template>

<script>
import { fetchAccountScore } from '@/api/adManagement';

export default {
  name: 'AccountScore',
  props: {
    accountId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      score: null,
    };
  },
  watch: {
    accountId: {
      handler(newVal) {
        if (newVal) {
          this.getAccountScore();
        } else {
          this.score = null;
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getAccountScore() {
      if (!this.accountId) {
        this.score = null;
        return;
      }
      this.loading = true;
      try {
        const res = await fetchAccountScore(this.accountId);
        // res.data 直接就是分数值
        if (res.code === 0) {
          this.score = res.data;
        } else {
          this.score = null;
        }
      } catch (error) {
        console.error('获取账户评分失败:', error);
        this.score = null;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.account-score {
  display: inline-flex;
  align-items: center;
  margin-left: 12px;
  font-size: 14px;
  color: #fff;
}

.loading {
  color: #fff;
}

.score-value {
  color: #fff;
}

.score-placeholder {
  color: rgba(255, 255, 255, 0.6);
}
</style>
